var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4C5F7E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.4H24.5V23.6H15.5V25.4ZM15.5 21.8H24.5V20H15.5V21.8ZM13.25 29C12.6313 29 12.1016 28.8237 11.6609 28.4713C11.2203 28.1187 11 27.695 11 27.2V12.8C11 12.305 11.2203 11.8812 11.6609 11.5287C12.1016 11.1762 12.6313 11 13.25 11H22.25L29 16.4V27.2C29 27.695 28.7797 28.1187 28.3391 28.4713C27.8984 28.8237 27.3687 29 26.75 29H13.25ZM21.125 17.3V12.8H13.25V27.2H26.75V17.3H21.125ZM13.25 12.8V17.3V12.8V17.3V27.2V12.8Z",
    fill: "#003EA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatement);
export default __webpack_public_path__ + "static/media/ic-statement.ea96697557e868858d726e461b6a7484.svg";
export { ForwardRef as ReactComponent };